import React from 'react';
import { HeadingRouterLink, HeadingRouterLinkProps } from './HeadingRouterLink';

type ChameleonHeadingRouterLinkProps = Omit<HeadingRouterLinkProps, 'color'>;

export function ChameleonHeadingRouterLink(props: ChameleonHeadingRouterLinkProps) {
    return <HeadingRouterLink {...props} color="chameleon" />;
}
